import get from 'lodash/get'
import AuthService from 'services/AuthService'
import UserRolesEnum from '../enums/UserRolesEnum'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isPracticeAncillary() || AuthService.isUserPracticeOther() || AuthService.isUserPracticeDemo()) {
                return next()
            }
            if (
                !AuthService.isUserPhysician() &&
                ![UserRolesEnum.PHYSICIAN.ID, UserRolesEnum.NURSE_PRACTITIONER.ID].includes(
                    get(AuthService.getActiveMember(), 'userRole.id'),
                )
            ) {
                if (AuthService.getUser().isMasterUser) {
                    return next({ name: 'practice.members' })
                }

                const members = AuthService.getMembers()
                return members.length > 1 && members.some(({ userRole }) => userRole && userRole.id === 1)
                    ? next({ name: 'auth.select-physician' })
                    : next({ name: 'auth.invite-member' })
            }
            return next()
        })
    },
}
